<template>
    <div class="widget" :class="{ 'is-loading': isLoading }" style="margin-bottom: 30px;">
        <h3>&nbsp;</h3>

        <div class="widget__inner">
            <h1>Welkom, {{ currentUser.name }}!</h1>
            <p>De laatste login was op {{ currentUser.last_login | formatDate }}.</p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
	import { mapGetters } from 'vuex'

	export default {
		data () {
			return {
				isLoading: false,
			}
		},

		computed: {
			...mapGetters([
				'currentUser',
			]),
		},

		filters: {
			formatDate (value) {
                return moment(value).locale('nl').format('LLLL')
			},
		},
	}
</script>

<style scoped lang="scss">
    h1 {
        font-size: 22px !important;
    }

    p {
        margin-bottom: 0;
    }
</style>